/**
 * Workflow status enumerator
 */
import {Base} from "./base.model";

export enum GenericStatus {
  Active = 'A',
  Inactive = 'I'
}

/**
 * Base class for database responses
 */
export class Auditable<S=GenericStatus> extends Base {
  createUser: string;
  createDt: Date;
  updateUser: string;
  updateDt: Date;

  statusCd: GenericStatus;

  constructor(object?: Auditable) {
    super(object);
  }

  setProperties(object: Auditable) {
    super.setProperties(object);
    this.createDt = object.createDt ? new Date(object.createDt) : this.createDt;
    this.updateDt = object.updateDt ? new Date(object.updateDt) : this.updateDt;
  }
}
